import React, { Suspense } from 'react';

const Loading = () => <span>Loading...</span>;

/**
 * Helper HOC to standardize creating modules that load via code splitting
 */
const loadableModule = dynamicImport => {
    const LazyComponent = React.lazy(dynamicImport);
    return props => (
        <Suspense fallback={<Loading />}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

export default loadableModule;
